import type { Nullable } from 'corgi-types';
import type { Article } from 'graphql-ts-types';
import { ArticleImageFormat } from 'graphql-ts-types';

import type { Variation } from '../../../../product-mvc-buttons/components/types';
import { executeQuery } from '../../../gql';
import type { ArticleVariationsQueryQueryVariables } from '../../../gql/generated/schema';
import isWebpSupported from '../../../utils/isWebpSupported';
import gqlQuery from '../gql/variations.gql';

type ArticlesWithVariation = Omit<Article, 'variations'> & {
  variations: Variation[];
};

interface Response {
  articles: Array<Nullable<ArticlesWithVariation>>;
}

export const fetchVariations = async ({
  sku,
  locale,
}: Omit<ArticleVariationsQueryQueryVariables, 'imageFormat'>): Promise<Variation[]> => {
  const response = await executeQuery<Response, ArticleVariationsQueryQueryVariables>({
    query: gqlQuery,
    variables: {
      sku,
      locale,
      ...(isWebpSupported() && { imageFormat: ArticleImageFormat.Webp }),
    },
  });

  const [article] = response.articles;

  return article?.variations ?? [];
};
